import { useMutation } from "@tanstack/react-query";
import posthog from "posthog-js";
import { toast } from "sonner";
import { useTRPC } from "@/trpc/client";

export const useCreateStripeSession = () => {
  const trpc = useTRPC();
  return useMutation(
    trpc.stripe.createSession.mutationOptions({
      onSuccess: ({ url, kind }, variables) => {
        // Existing subscribers get a billing portal session, not a checkout —
        // only the latter belongs in the checkout funnel. sendBeacon so the
        // event survives the navigation on the next line.
        if (kind === "checkout") {
          posthog.capture(
            "checkout_started",
            {
              plan: variables?.plan ?? "monthly",
              variant: variables?.variantKey ?? "unknown",
              study_set_id: variables?.studySetId,
            },
            { transport: "sendBeacon" },
          );
        }
        if (url) window.location.href = url;
        if (!url)
          toast.error("There was a problem...", {
            description: "Please try again in a moment.",
          });
      },
      onError: (error) => {
        console.error("Failed to create stripe session", error);
        toast.error("Failed to create stripe session");
      },
    }),
  );
};
